import React, { useContext, useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Home from "./pages/home/home";
import Login from "./pages/login_signUpPage/login";
import MBTIPage from "./pages/MBTIForm/MBTIPage";
import EditProfile from "./pages/userProfile/editProfile";
import "react-toastify/dist/ReactToastify.css";
import { MDBSpinner } from "mdb-react-ui-kit";
import { useDispatch, useSelector } from "react-redux";
// --- MATRIX IMPORTS ---
import { MatrixProvider, useMatrix } from "./context/MatrixContext";
import AddTeamMember from "./pages/addTeamMemeber/AddTeamMember";
import ForgotPass from "./pages/login_signUpPage/ForgotPass/ForgotPass";
import Messages from "./pages/messages/Messages";
import VerifyMobile from "./pages/verifyMobile/VerifyMobile";
import { getAllUserInfo } from "./Store/UserAction";

// --- HELPER: Handles Auto-Reconnect ---
const MatrixConnectionManager = ({ userData }) => {
	const { initMatrix, client } = useMatrix();

	useEffect(() => {
		// Only try to connect if we aren't already connected
		if (client) return;

		const savedConfig = localStorage.getItem("matrix_config");

		// Connect if we have config AND user data (meaning we are logged in)
		if (savedConfig && userData) {
			try {
				const config = JSON.parse(savedConfig);
				if (config && config.access_token) {
					console.log("🔄 Restoring Matrix Connection...");
					initMatrix(config);
				}
			} catch (e) {
				console.error("Failed to parse matrix config", e);
			}
		}
	}, [client, initMatrix, userData]);

	return null;
};

function App() {
	const dispatch = useDispatch();
	const { loading, data } = useSelector((state) => state.user);

	useEffect(() => {
		// ✅ BUG FIX: Only request User Info if a token actually exists.
		// This stops the red "No Token" alert for new/logged-out users.
		const token = localStorage.getItem("token");
		if (token) {
			dispatch(getAllUserInfo());
		}
	}, [dispatch]);

	return (
		<MatrixProvider>
			{/* Pass user data so it knows when to connect */}
			<MatrixConnectionManager userData={data} />

			<div className="vh-100 bg-light vazir">
				<ToastContainer
					position="top-center"
					autoClose={5000}
					hideProgressBar={false}
					newestOnTop={false}
					closeOnClick
					rtl={true}
					pauseOnFocusLoss
					draggable
					pauseOnHover
				/>
				{loading ? (
					<div
						className={
							"h-100 w-100 d-flex justify-content-center align-items-center"
						}
					>
						<MDBSpinner color="primary" size={"lg"}>
							<span className="visually-hidden">Loading...</span>
						</MDBSpinner>
					</div>
				) : (
					<Routes>
						<Route
							path="/login"
							element={!data ? <Login /> : <Navigate to={"/home"} />}
						/>
						<Route
							path="/signup"
							element={
								!data ? <Login isSignup={true} /> : <Navigate to={"/home"} />
							}
						/>
						<Route
							path="/home"
							element={data ? <Home /> : <Navigate to={"/login"} />}
						/>
						<Route
							path="/userProfile"
							element={data ? <EditProfile /> : <Navigate to={"/login"} />}
						/>
						<Route
							path="/mbti-form"
							element={data ? <MBTIPage /> : <Navigate to={"/login"} />}
						/>
						<Route
							path="/add-team-member"
							element={data ? <AddTeamMember /> : <Navigate to={"/login"} />}
						/>
						<Route
							path="/messages"
							element={data ? <Messages /> : <Navigate to={"/login"} />}
						/>
						<Route path="/verify-mobile/:userId" element={<VerifyMobile />} />
						<Route
							path="/forgot-password"
							element={!data ? <ForgotPass /> : <Navigate to={"/home"} />}
						/>

						<Route
							path="/"
							element={data ? <Navigate to={"/home"} /> : <Login />}
						/>
					</Routes>
				)}
			</div>
		</MatrixProvider>
	);
}

export default App;
